import React from 'react';
import { inject, observer } from 'mobx-react';
import { Form, Input, Radio, Button, Icon, Tooltip } from 'antd';
import util from '../../util';
import EcodeEmpty from './EcodeEmpty';

const { getPermissions } = util;

const FormItem = Form.Item;
const TextArea = Input.TextArea;

const store = [
  'devStore'
]
@inject(...store)
@observer
class App extends React.Component {
  static defaultProps = {
    prefixCls: 'ecode-dev-content'
  }
  componentDidMount() {
  }

  /**
   * 提交表单
   */
  submit = () => {
    const { devStore: { appAuthorized } } = this.props;
    const { validateFields, resetFields } = this.props.form;
    validateFields((errors, values) => {
      if(!errors) {
        appAuthorized(values).then(() => resetFields());
      }
    })
  }

  render() {
    const { prefixCls, form } = this.props;
    const { getFieldDecorator, resetFields } = form;
    const formItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
    };
    if(getPermissions()) return <EcodeEmpty />;
    return (
      <div className={`${prefixCls}`}>
        <div className={`${prefixCls}-form`}>
          <Form {...formItemLayout}>
            <FormItem
              label="类型"
            >
              {
                getFieldDecorator("type", {
                  initialValue: "temporary",
                  rules: [
                    {
                      required: true,
                      message: '类型不能为空',
                    },
                  ],
                })(
                  <Radio.Group>
                    <Radio value="temporary">临时</Radio>
                    <Radio value="permanent">永久</Radio>
                  </Radio.Group>
                )
              }
              <Tooltip placement="right" title={"临时：7天"}>
                <Icon className="pointer" type="question-circle" />
              </Tooltip>
            </FormItem>
            <FormItem
              label="AppID"
            >
              {
                getFieldDecorator("appId", {
                  initialValue: "",
                  rules: [
                    {
                      required: true,
                      message: 'AppID不能为空',
                    },
                  ],
                })(<Input />)
              }
            </FormItem>
            <FormItem
              label="标识码"
            >
              {
                getFieldDecorator("authKey", {
                  initialValue: "",
                  rules: [
                    {
                      required: true,
                      message: '标识码不能为空',
                    },
                  ],
                })(<TextArea autoSize={{minRows: 4, maxRows: 4}} />)
              }
            </FormItem>
            <FormItem wrapperCol={{span: 24}} className={`${prefixCls}-btns`}>
              <Button onClick={() => resetFields()}>重置</Button>
              <Button type="primary" onClick={this.submit}>提交</Button>
            </FormItem>
          </Form>
        </div>
      </div>
    )
  }
}

App = Form.create()(App);
export default App;


// WEBPACK FOOTER //
// ./src/components/dev/Application.js